/*
 * cp-cart-supplements.js — Option d'inscription personnalisée (oct. 2026)
 * Garde la quantité de chaque ligne « Supplément » (ex. gravure similicuir, ajoutée en ligne
 * imbriquée par product-form.js) égale à celle de son produit parent.
 *  - Après chaque mise à jour du panier (événement Dawn cartUpdate) et au chargement si besoin.
 *  - Supplément sans parent (ajout par lien direct, etc.) : retiré.
 *  - Une seule synchronisation à la fois ; relancée sur l'état le plus récent si d'autres actions arrivent.
 * La suppression du parent retire déjà le supplément côté Shopify (lignes imbriquées).
 * Chargé par snippets/cart-drawer.liquid.
 */
(function () {
  if (window.CPCartSupplements) return;

  var SUPPLEMENT_TYPE = 'Supplément';
  var running = false;
  var again = false;

  function cartUrl(path) {
    var r = window.routes || {};
    return (r[path] || ({ cart_url: '/cart', cart_update_url: '/cart/update' })[path]);
  }

  function computeUpdates(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;
    var byKey = {};
    cart.items.forEach(function (item) { byKey[item.key] = item; });

    var updates = {};
    var count = 0;
    cart.items.forEach(function (item) {
      if (item.product_type !== SUPPLEMENT_TYPE) return;
      var parentKey = item.parent_relationship && item.parent_relationship.parent_key;
      var target = parentKey && byKey[parentKey] ? byKey[parentKey].quantity : 0;
      if (item.quantity !== target) {
        updates[item.key] = target;
        count++;
      }
    });
    return count ? updates : null;
  }

  // Sections du thème à rafraîchir (tiroir + page panier), dédoublonnées (5 max. par requête Shopify)
  function sectionsToRender() {
    var list = [];
    var seen = {};
    document.querySelectorAll('cart-drawer-items, cart-items').forEach(function (el) {
      if (typeof el.getSectionsToRender !== 'function') return;
      var sections;
      try { sections = el.getSectionsToRender(); } catch (e) { return; }
      sections.forEach(function (s) {
        if (!s || !s.section || seen[s.section]) return;
        seen[s.section] = true;
        list.push({ owner: el, id: s.id, section: s.section, selector: s.selector });
      });
    });
    return list.slice(0, 5);
  }

  function render(state, list) {
    if (!state || !state.sections) return;
    list.forEach(function (x) {
      var html = state.sections[x.section];
      var host = document.getElementById(x.id);
      if (!html || !host || typeof x.owner.getSectionInnerHTML !== 'function') return;
      var target = (x.selector && host.querySelector(x.selector)) || host;
      target.innerHTML = x.owner.getSectionInnerHTML(html, x.selector);
    });
    var empty = state.item_count === 0;
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.toggle('is-empty', empty);
    var footer = document.getElementById('main-cart-footer');
    if (footer) footer.classList.toggle('is-empty', empty);
  }

  function sync() {
    if (running) { again = true; return; }
    running = true;

    fetch(cartUrl('cart_url') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var updates = computeUpdates(cart);
        if (!updates) return null;

        var list = sectionsToRender();
        var body = { updates: updates };
        if (list.length) {
          body.sections = list.map(function (x) { return x.section; });
          body.sections_url = window.location.pathname;
        }

        return fetch(cartUrl('cart_update_url'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then(function (response) { return response.json(); })
          .then(function (state) {
            if (state && !state.status && !state.errors) render(state, list);
          });
      })
      .catch(function (e) { console.error('[CP supplements]', e); })
      .then(function () {
        running = false;
        if (again) { again = false; sync(); }
      });
  }

  window.CPCartSupplements = { sync: sync };

  function start() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { sync(); });
    }
    // Au chargement : seulement si un supplément est affiché ou sur la page panier
    if (document.querySelector('.cart-item__nested-line') || document.getElementById('main-cart-items')) sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();